var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5 13.125c-1.03553 0-1.875.8395-1.875 1.875s.83947 1.875 1.875 1.875 1.875-.8395 1.875-1.875-.83947-1.875-1.875-1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.125 15c0-1.0355.8395-1.875 1.875-1.875s1.875.8395 1.875 1.875-.8395 1.875-1.875 1.875-1.875-.8395-1.875-1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.625 15c0-1.0355.8395-1.875 1.875-1.875s1.875.8395 1.875 1.875-.8395 1.875-1.875 1.875-1.875-.8395-1.875-1.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.8f0ac7c1845ad6021f34dc07b28e144f.svg";
export { ForwardRef as ReactComponent };